import React from "react";
import Navbar from "../components/common/Navbar";

const HeroSection = ({ landingPageData }) => {
  return (
    <div>
      <div className="relative lg:mb-24 hidden lg:block" id="about-program">
        {/* Navbar */}
        <div className="absolute top-0 left-0 right-0 z-50">
          <Navbar landingPageData={landingPageData?.header?.navLinks} />
        </div>

        {/* Hero Section with Background Image */}

        <div
          className="
    relative flex flex-col lg:flex-row items-center lg:items-start justify-between
    h-[60vh] lg:h-[60vh] xl:h-[70vh] 2xl:h-[75vh] 3xl:h-[80vh] 4xl:h-[80vh]
  "
          style={{
            backgroundImage: `url('/images/hero/hero-bg-img.webp')`,
            backgroundSize: "auto 100%",
            backgroundPosition: "top right",
            backgroundRepeat: "no-repeat",
            padding: "2rem",
          }}
        >
          {/* Left Shape (Hidden on Mobile) */}
          <img
            src="/images/hero/hero-left-shape.webp"
            alt="Left Shape"
            className="absolute left-0 top-16 lg:top-20 w-80 h-400 hidden lg:block"
            aria-hidden="true"
          />

          {/* Text Section */}
          <div className="p-8 lg:px-[6%] xl:px-[8%] 2xl:px-[7%] 3xl:px-[12%] 4xl:px-[15%] 5xl:px-[16%] 6xl:px-[21%] 7xl:px-[21%] lg:mt-64">
            <h1 className="text-18 lg:text-20 font-[700] text-yellow ">
              {landingPageData.heroSection.title1}
            </h1>

            <h1 className="text-4xl lg:text-[55px] font-[900] text-gray-800 w-full leading-snug lg:leading-snug">
              {landingPageData.heroSection.title2}
            </h1>

            <p className="text-[1rem] max-w-[573px] font-[400] mt-4 text-textBlack leading-7 lg:leading-7">
              {landingPageData.heroSection.description}
            </p>

            <a
              href={landingPageData.heroSection.ctaLink}
              className="mt-6 bg-blue text-white py-3 px-6 rounded-md flex justify-center items-center max-w-200 cursor-pointer"
            >
              {landingPageData.heroSection.ctaText}
            </a>
          </div>
        </div>
      </div>

      <div className="relative lg:mb-24 block lg:hidden" id="about-program">
        {/* Navbar */}
        <div className="absolute top-0 left-0 right-0 z-50">
          <Navbar landingPageData={landingPageData?.header?.navLinks} />
        </div>
        {/* Hero Section */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  relative ">
          {/* Left Shape (Hidden on Mobile) */}
          <img
            src="/images/hero/hero-left-shape.webp"
            alt="Left Shape"
            className="absolute left-0 top-16 lg:top-20 w-80 h-400 hidden lg:block"
            aria-hidden="true"
          />
          {/* Right Side Image (Moved on Top for Mobile) */}
          <div className="flex  lg:justify-start relative z-10 order-first lg:order-last ">
            <img
              src="/images/hero/hero-bg-img.webp"
              className="w-full lg:w-auto h-auto lg:h-auto object-cover object-top max-h-[100vh]"
              alt="Hero"
            />
          </div>
          {/* Text Section */}
          <div className=" lg:text-left relative z-10 p-8 lg:p-28 lg:mt-64">
            <h1 className="text-18 lg:text-20 font-[700] text-yellow ">
              {landingPageData.heroSection.title1}
            </h1>

            <h1 className="text-4xl lg:text-55 font-[900] text-gray-800 w-full leading-snug lg:leading-snug">
              {landingPageData.heroSection.title2}
            </h1>

            <p className="text-16 font-[400] mt-4 text-textBlack leading-7 lg:leading-7">
              {landingPageData.heroSection.description}
            </p>

            <a
              href={landingPageData.heroSection.ctaLink}
              className="mt-6 bg-blue text-white py-3 px-6 rounded-md flex justify-center items-center max-w-200 cursor-pointer"
            >
              {landingPageData.heroSection.ctaText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
